import { ApolloError, Operation } from '@apollo/client';
import { toString, take } from 'ramda';
import Logger from './Logger';
import { GraphQLError } from 'graphql';

export const doIf =
  <T>(action: (message: string, val: T) => void) =>
  (message: string, pred: (param: T) => boolean) =>
  (val: T): T => {
    if (pred(val)) {
      action(message, val);
    }
    return val;
  };

// Kasta ett fel om ett villkor är uppfyllt, annars returneras indata
// export const errorIf = <T>(message: string, pred: T => boolean) => (
//   val: T
// ): T => {
//   if (pred(val)) {
//     throw new Error(message);
//   }
//   return val;
// };
const formatMessage = (message: any, val: any) =>
  `${message}: ${(take(160), toString(val))}`;

export const errorIf = doIf((message, val) => {
  throw new Error(message);
});
export const errorlogIf: <T>(
  message: string,
  pred: (param: T) => boolean
) => void = doIf((message, val) => {
  Logger.error(formatMessage(message, val));
});

interface IGraphqlErrorExtraInfo {
  path: ReadonlyArray<string | number> | undefined;
  extensions:
    | {
        [key: string]: any;
      }
    | undefined;
  variables: string;
  querySource?: string;
  operationName: string;
  serverName: string;
  serverVersion: string;
  name: string;
}

const getGraphqlErrorName = (graphQLError: GraphQLError): string => {
  return graphQLError.extensions?.ExceptionClass ?? 'Error';
};

export const getGraphqlErrorExtraInfo = (
  graphQLError: GraphQLError,
  operation: Operation
): IGraphqlErrorExtraInfo => {
  let extraInfo: IGraphqlErrorExtraInfo = {
    path: graphQLError.path,
    extensions: graphQLError.extensions,
    variables: JSON.stringify(operation.variables, null, 2),
    operationName: operation.operationName,
    serverName: operation
      .getContext()
      .response.headers.get('AvenyService-Server-Name'),
    serverVersion: operation
      .getContext()
      .response.headers.get('AvenyService-Server-Version'),
    name: getGraphqlErrorName(graphQLError),
  };

  if (operation.query.loc) {
    extraInfo = {
      ...extraInfo,
      querySource: operation.query.loc.source.body,
    };
  }

  return extraInfo;
};

export const handleGQLError = (error: ApolloError) => {
  if (
    error.graphQLErrors.length > 0 &&
    !error.message.includes('Login required.')
  ) {
    throw error;
  }
};
